import { FEATURE_NAV_V01 } from "./featureFlags";

export const APP_NAME = FEATURE_NAV_V01 ? "Studio Pericles" : "Project Requirements Admin";

export const NAV_LABELS = {
  customers: FEATURE_NAV_V01 ? "Clients Management" : "Customers",
  projects: FEATURE_NAV_V01 ? "Workspaces" : "Projects",
  requirements: "Requirements",
};

export const ACTIVE_CUSTOMER_LABEL = FEATURE_NAV_V01 ? "Active client" : "Active customer";

export const ALL_CUSTOMERS_LABEL = FEATURE_NAV_V01 ? "All clients" : "All customers";

export const CUSTOMER_LABEL = FEATURE_NAV_V01 ? "Client" : "Customer";

export const PROJECT_LABEL = FEATURE_NAV_V01 ? "Workspace" : "Project";
